import CtaLarge from './ui/cta/CtaLarge'
import Icon from './svg/icon'
import Swoosh from './svg/Swoosh'
import { isStructuredTextEmpty } from '@/utils/datocms/isStructuredTextEmpty'
import { StructuredText } from 'react-datocms'
import type { SearchHeroFragment } from '@/lib/types/datocms/graphql/generated'

type Props = Pick<SearchHeroFragment, 'searchTitle' | 'searchDescription' | 'searchCta'>

export default function SearchParts({ searchTitle, searchDescription, searchCta }: Props) {
	return (
		<section className="parts-side-panel relative bg-white-frosted overflow-hidden md:-mt-8 z-10 @container">
			<div className="relative max-w-screen-2xl mx-auto text-center transition-all duration-300 s-ease py-20 @3xl:pt-32 @3xl:pb-32">
				<div className="relative flex flex-col items-center transition-opacity ease-out z-10">
					<Icon
						icon="Wrench"
						className="bg-white-frosted-shade w-20 h-20 p-6 rounded-full overflow-visible"
					/>
					<h3 className="font-medium text-2xl mt-6">
						{searchTitle ? searchTitle : 'Search Parts'}
					</h3>
					{searchDescription && !isStructuredTextEmpty(searchDescription) ? (
						<p className="opacity-80 mt-4">
							<StructuredText data={searchDescription.value} />
						</p>
					) : (
						<p className="opacity-80 mt-4">
							A combination of service and equipment that could only be Cottrell.
						</p>
					)}

					{searchCta ? (
						<CtaLarge
							icon={{ icon: 'Search', orientation: 'left' }}
							cta={searchCta}
							className="w-full mt-6 max-w-[365px]"
						/>
					) : (
						<CtaLarge
							icon={{ icon: 'Search', orientation: 'left' }}
							cta={{
								label: 'SEARCH NOW',
								__typename: 'NavigationItemRecord',
								id: 'search-now',
								useExternalLink: true,
								openInNewWindow: true,
								externalLink: 'https://shop.cottrelltrailers.com/PublicStore/',
							}}
							className="w-full mt-6 max-w-[365px]"
						/>
					)}
				</div>

				<Swoosh
					className="absolute bottom-0 right-0 origin-left @2xl:origin-center scale-[200%] @5xl:-translate-x-1/2 z-0"
					fill="#E6EDF7"
					opacity="1"
				/>
			</div>
		</section>
	)
}
